module.exports = __webpack_public_path__ + "static/media/legion_commander.20ad2cee.png";